export var NotificationUrgency;
(function (NotificationUrgency) {
    NotificationUrgency["INFO"] = "info";
    NotificationUrgency["ALERT"] = "alert";
    NotificationUrgency["CRITICAL"] = "critical";
})(NotificationUrgency || (NotificationUrgency = {}));
